import { useQuery } from '@tanstack/react-query';
import { plantSourceApi } from '../lib/plantSourceApi';
import { PlantSourceSearchParams } from '../types/plantSource';

export function usePlantSources(params: PlantSourceSearchParams = {}) {
  const { search, type, scope, userId, sortBy, sortOrder, limit = 50, offset = 0 } = params;

  return useQuery({
    queryKey: ['plantSources', search, type, scope, userId, sortBy, sortOrder, limit, offset],
    queryFn: () =>
      plantSourceApi.getPlantSources({
        search: search || undefined,
        type,
        scope,
        userId,
        sortBy,
        sortOrder,
        limit,
        offset,
      }),
  });
}

export function usePlantSource(id: string | undefined) {
  return useQuery({
    queryKey: ['plantSource', id],
    queryFn: () => plantSourceApi.getPlantSource(id!),
    enabled: !!id,
  });
}

export function usePlantSourceByQrCode(qrCodeId: string | undefined) {
  return useQuery({
    queryKey: ['plantSourceByQrCode', qrCodeId],
    queryFn: () => plantSourceApi.getPlantSourceByQrCode(qrCodeId!),
    enabled: !!qrCodeId,
  });
}
